import React from "react";
import { TProps } from "./PaymentRequestRedirect.types";
import { isOpen } from "@rentiohq/shared-frontend/dist/utils/paymentRequest.utils";
import { Navigate } from "react-router-dom";

class PaymentRequestRedirect extends React.Component<TProps> {
  // Render
  public render() {
    const { paymentRequest } = this.props;
    if (!paymentRequest) {
      return null;
    }

    if (isOpen(paymentRequest)) {
      return null;
    }

    return <Navigate to="/" />;
  }
}

export default PaymentRequestRedirect;
